module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XI",
      "title": "XI"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "mev1"
  }, [_c('b', [_vm._v("ALTHOUGH I’M RATHER CRITICAL")])]), _vm._v(" of social media in this book, I should begin by confessing that this project was sparked by a Twitter conversation. Noah Toly and Martyn Wendell Jones exchanged tweets about the need for a book on how Christians should consume the news. That was the provocation I needed to begin organizing some long-standing thoughts and ideas I had on this topic. When I tweeted that I was drafting a book in response, Jon Boyd wrote me to express his interest in the project. So my thanks go to Noah and Martyn (and even, I suppose, to Twitter, or really to the wonderful people who find ways to use that tool redemptively); I’m sure this isn’t the book they had in mind, but I hope it proves to be helpful to some readers nonetheless.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Writing can be a lonely endeavor, but I’m grateful for my family, friends, and colleagues who discussed some of these ideas with me, read drafts, and reminded me that belonging well precedes thinking well. My parents read and commented on a full draft, and many of my colleagues at Spring Arbor University asked me hard questions that made the final version better. Jon’s keen editorial eye and the comments from IVP’s anonymous readers also guided my revisions. If stupid claims remain, I have only myself to blame. I’m also grateful for the course release that Spring Arbor University granted me to complete this book and for the remarkable team of librarians at the White Library.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XII",
      "title": "XII"
    }
  }, [_vm._v("The "), _c('i', [_vm._v("Front Porch Republic")]), _vm._v(" community has been a source of great encouragement to me: Matt Stewart and Eric Miller in particular helped me hone some of my thinking on these matters. When I told Jason Peters I was working on a book about how we should read the news, he replied, “That would be a short book if I wrote it: ‘Ignore it.’” Despite his judgment of the subject, he has been much kinder to the author.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The dedication records my greatest debt.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d0e461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre2.vue
// module id = 69
// module chunks = 0